import moment from 'moment';
import {
  getUserAbnormalReportDownLoad,
  getUserStatisticsReport
} from '../services/report';
import { getZoneTreeData } from '../services/calender';

export default {
  namespace: 'userAbnormallyReport',
  state: {
    deptName: '',
    deptId: '',
    startTime: moment()
      .startOf('day')
      .valueOf(),
    endTime: moment()
      .endOf('day')
      .valueOf(),
    userName: '',
    pageNo: 1,
    pageSize: 10,
    searchData: [],
    meetingTreeData: { child: [] },
    meetingSearchInfo: {
      meetingType: undefined,
      meetingDevice: undefined,
      moreMeeting: []
    }
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    },
    setMeetingTreeData(state, { meetingTreeData }) {
      return { ...state, meetingTreeData };
    }
  },
  effects: {
    *search(undefined, { call, select, put }) {
      const { token } = yield select(state => state.login);
      let startTime = yield select(
        state => state.userAbnormallyReport.startTime
      );
      let endTime = yield select(state => state.userAbnormallyReport.endTime);
      let userName = yield select(state => state.userAbnormallyReport.userName);
      let deptId = yield select(state => state.userAbnormallyReport.deptId);
      let meetingSearchInfo = yield select(
        state => state.userAbnormallyReport.meetingSearchInfo
      );
      let pageNo = yield select(state => state.userAbnormallyReport.pageNo);
      let pageSize = yield select(state => state.userAbnormallyReport.pageSize);
      let id = meetingSearchInfo.moreMeeting;
      let roomIds = (id && id.length > 0 && id.join(';')) || '';
      const { locale } = yield select(state => state.i18n);
      // let data = yield call(getuserReport, {
      //   startDate: startTime.startOf('day').valueOf(),
      //   endDate: endTime.endOf('day').valueOf(),
      //   userName,
      //   roomIds,
      //   locale,
      //   pageNo,
      //   pageSize,
      //   token})
      let data = yield call(getUserStatisticsReport, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        deptIds: deptId,
        userName,
        locale,
        pageNo,
        pageSize,
        token
      });
      if (data) {
        yield put({
          type: 'setState',
          payload: { searchData: data.data || [] }
        });
      }
    },
    *changePage({ payload }, { call, select, put }) {
      yield put({ type: 'setState', payload: { ...payload } });
      const { token } = yield select(state => state.login);
      let startTime = yield select(
        state => state.userAbnormallyReport.startTime
      );
      let endTime = yield select(state => state.userAbnormallyReport.endTime);
      let userName = yield select(state => state.userAbnormallyReport.userName);
      let deptId = yield select(state => state.userAbnormallyReport.deptId);
      // let meetingSearchInfo = yield select(state => state.userReport.meetingSearchInfo)
      let pageNo = yield select(state => state.userAbnormallyReport.pageNo);
      let pageSize = yield select(state => state.userAbnormallyReport.pageSize);
      // let id = meetingSearchInfo.moreMeeting
      // let roomIds = id && id.length > 0 && id.join(';') || ''
      const { locale } = yield select(state => state.i18n);
      let data = yield call(getUserStatisticsReport, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        deptIds: deptId,
        userName,
        locale,
        pageNo,
        pageSize,
        token
      });
      if (data) {
        yield put({
          type: 'setState',
          payload: { searchData: data.data || [] }
        });
      }
    },
    *downloadUser({}, { select, call }) {
      const { token } = yield select(state => state.login);
      let startTime = yield select(
        state => state.userAbnormallyReport.startTime
      );
      let endTime = yield select(state => state.userAbnormallyReport.endTime);
      let userName = yield select(state => state.userAbnormallyReport.userName);
      let deptId = yield select(state => state.userAbnormallyReport.deptId);
      let meetingSearchInfo = yield select(
        state => state.userAbnormallyReport.meetingSearchInfo
      );
      let id = meetingSearchInfo.moreMeeting;
      let roomIds = (id && id.length > 0 && id.join(';')) || '';
      const { locale } = yield select(state => state.i18n);
      yield call(getUserAbnormalReportDownLoad, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        creatorNames: userName,
        deptIds: deptId,
        locale,
        token
      });
    },
    *getMeetingTreeDataForSearch({}, { select, put, call }) {
      const { locale } = yield select(state => state.i18n);
      const data = yield call(getZoneTreeData, {
        pageNo: '',
        pageSize: '',
        startTime: moment()
          .startOf('day')
          .valueOf(),
        endTime: '',
        flag: 3,
        otherRoomIds: '',
        audit: '',
        name: '',
        deviceIds: '',
        teaIds: '',
        lang: locale
      });
      yield put({ type: 'setMeetingTreeData', meetingTreeData: data.data });
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname, query }) => {
        if (pathname.indexOf('userAbnormallyReport') > -1) {
          dispatch({ type: 'getMeetingTreeDataForSearch' });
          const fromDetail = query.detail;
          if (!fromDetail) {
            let p = {
              startTime: moment().subtract(1, 'days'),
              endTime: moment().subtract(1, 'days'),
              userName: '',
              pageNo: 1,
              pageSize: 10,
              searchData: [],
              meetingTreeData: { child: [] },
              meetingSearchInfo: {
                meetingType: undefined,
                meetingDevice: undefined,
                moreMeeting: []
              }
            };
            dispatch({ type: 'setState', payload: p });
          }
        } else if (
          pathname.indexOf('userAbnormallyReport') !== -1 ||
          pathname.indexOf('userReport') !== -1
        ) {
          dispatch({
            type: 'account/getAllDept'
          });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/userReportAbnormally.js